import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Header from "../Header/Header";
import {
  createCheckoutSession,
  getSubscriptionPlanList,
  createCheckoutSessionForOneTimePayment,
  cancelSubscription,
} from "../../redux/subscriptionSlice";

const SubscriptionPlan = () => {
  const dispatch = useDispatch();
  const [planList, setPlanList] = useState(null);
  const [loading, setLoading] = useState(false);
  const [profileData, setProfileData] = useState(null);
  const [extraUsers, setExtraUsers] = useState(null);
  const [currentplan, setCurrentPlan] = useState(null);

  const subscriptionPlanListResponse = useSelector(
    (state) => state.subscriptionPlan.subscriptionPlans
  );
  const profileResponse = useSelector((state) => state.getProfileReducer.data);

  useEffect(() => {
    setLoading(false);
    dispatch(getSubscriptionPlanList());
  }, [dispatch]);

  useEffect(() => {
    if (profileResponse != null && profileResponse.status === 1) {
      setProfileData(profileResponse.data);
    }
  }, [profileResponse]);

  useEffect(() => {
    if (subscriptionPlanListResponse) {
      setPlanList(subscriptionPlanListResponse);
    }
  }, [subscriptionPlanListResponse]);

  useEffect(() => {
    if (profileData && planList) {
      const currentPlanId = profileData?.userSubscription?.subscriptionPlanId;
      const matchedPlan = planList.find((plan) => plan._id === currentPlanId);
      if (matchedPlan) {
        setCurrentPlan(matchedPlan);
      }
    }
  }, [profileData, planList]);

  const handleCheckout = (planId) => {
    setLoading(true);
    try {
      dispatch(createCheckoutSession({ planId })).then((res) => {
        if (res.error) {
          alert("Something went wrong");
          setLoading(false);
          return;
        }
        window.location.href = res.payload.data.url;
      });
    } catch (error) {
      console.error("Checkout error:", error);
      alert("Something went wrong during checkout.");
      setLoading(false);
    }
  };
  const handleExtraUserCheckout = () => {
    if (!extraUsers || extraUsers <= 0) {
      alert("No of employee count must be posutive number");
      return;
    }
    setLoading(true);
    try {
      dispatch(
        createCheckoutSessionForOneTimePayment({ count: Number(extraUsers) })
      ).then((res) => {
        if (res.error) {
          alert("Something went wrong");
          setLoading(false);
          return;
        }
        window.location.href = res.payload.data.url;
      });
    } catch (error) {
      console.error("Checkout error:", error);
      alert("Something went wrong during checkout.");
      setLoading(false);
    }
  };

  const handleCancelSubscription = () => {
    // setLoading(true);
    try {
      dispatch(
        cancelSubscription({
          subscriptionId: profileData?.userSubscription?.stripeSubscriptionId,
        })
      ).then((res) => {
        if (res.error) {
          alert("Something went wrong");
          // setLoading(false);
          return;
        }
        alert("Subscription cancelled successfully!");
        window.location.reload();
      });
    } catch (error) {
      console.error("Checkout error:", error);
      alert("Something went wrong during checkout.");
      // setLoading(false);
    }
  };

  return (
    <div className="sidebar_mar">
      <Header />
      <div className="project_btn_style">
        <h2>Subscription Plans</h2>
      </div>

      <div className={`content-wrapper ${loading ? "blurred" : ""}`}>
        {/* {profileData && profileData.isSubscribed === 1 && (
          <div className="extra-user-purchase-section">
            <div className="extra-user-section">
              {currentplan && (
                <p
                  className="extraprice-info"
                  style={{
                    fontSize: "0.9rem",
                    color: "#16a34a",
                    marginBottom: "20px",
                  }}
                >
                  Your current{" "}
                  <span
                    style={{
                      background: "gray",
                      padding: "3px 10px",
                      borderRadius: "4px",
                      color: "#ffffff",
                    }}
                  >
                    {currentplan.name} plan
                  </span>{" "}
                  will be canceled after the current active plan expires.
                </p>
              )}
              <button
                style={{ background: "red" }}
                className="continue-btn"
                onClick={handleCancelSubscription}
              >
                Cancel Subscription
              </button>
            </div>
          </div>
        )} */}

        <div className="plan-card-wrapper">
          {planList?.length > 0 &&
            planList.map((plan, index) => (
              <div key={index} className={`plan-card`}>
                <div className="plan-card-header">
                  <div className="gradient-border">
                    <h3>{plan.name}</h3>
                  </div>
                </div>

                <div className="plan-card-body">
                  <div className="price">
                    ${plan.basePrice}
                    <span className="pipe"></span>
                    {plan.durationType !== "one-time" ? (
                      <span className="duration">
                        {plan.duration} {plan.durationType}
                        {plan.duration > 1 ? "s" : ""}
                      </span>
                    ) : (
                      <span className="duration">one time</span>
                    )}
                  </div>

                  {plan.discount > 0 && (
                    <p className="discount">
                      {plan.discount}% Discount Applied
                    </p>
                  )}
                  {plan.extraUserPriceObj &&
                    plan.extraUserPriceObj !== null && (
                      <p className="extrauser">
                        Pay{" "}
                        <span className="discount">
                          only ${plan?.extraUserPriceObj?.basePrice}
                        </span>{" "}
                        <br />
                        for extra user
                      </p>
                    )}

                  <p className="users">
                    Includes <strong>{plan.usersIncluded}</strong> users
                  </p>
                </div>

                <div className="plan-card-footer">
                  {profileData && (
                    <button
                      className="continue-btn"
                      onClick={() => handleCheckout(plan._id)}
                      disabled={profileData.isSubscribed === 1 ? true : false}
                    >
                      {plan.isRecommended
                        ? "Recommended Plan"
                        : "Continue Plan"}
                    </button>
                  )}
                </div>
              </div>
            ))}
        </div>

        {profileData && profileData.isSubscribed === 1 && (
          <div className="extra-user-purchase-section">
            <h3>Purchase Extra Users</h3>

            <div className="extra-user-section">
              <div>
                <label>No of extra employee:</label>
                <input
                  type="number"
                  value={extraUsers}
                  onChange={(e) => setExtraUsers(e.target.value)}
                  placeholder="0"
                />
              </div>
              {planList?.length > 0 && planList[0].extraUserPriceObj && (
                <p
                  className="extraprice-info"
                >
                  Pay <span>only ${planList[0]?.extraUserPriceObj?.basePrice}</span> per
                  extra user
                </p>
              )}
              <button
                className="continue-btn"
                onClick={handleExtraUserCheckout}
              >
                Proceed to Checkout
              </button>
            </div>
          </div>
        )}
      </div>

      {loading && (
        <div className="loading-overlay">
          <p>Processing checkout...</p>
        </div>
      )}
    </div>
  );
};

export default SubscriptionPlan;
